module.exports = "<h1>Uživatelé</h1>\n<a href=\"#\" routerLink=\"/user\" class=\"float-right\">Nový</a>\n<table class=\"table table-bordered\">\n  <th>Jméno</th>\n  <th>Přihlašovací jméno</th>\n  <th>Tlačítko</th>\n  <th>Změnit</th>\n  <th>Odstranit</th>\n  <tr *ngFor=\"let user of users\">\n    <td>{{user.name}}</td>\n    <td>{{user.username}}</td>\n    <td><app-sbutton [a]=\"false\" [s]=\"{'user': user}\"></app-sbutton></td>\n    <td><a href=\"#\" routerLink=\"/user/{{user.id}}\">X</a></td>\n    <td><a href=\"#\" (click)=\"remove(u.id, $event)\">X</a></td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.html
// module id = 468
// module chunks = 1